import React from 'react';

const Download = (props: any) => {
  return (
    <div className={props.className}>
      <span>下载Chrome浏览器</span>
      <a href={`attachments/ChromeStandaloneSetup.exe`} download="谷歌浏览器.exe">32位</a>
      <a href={`attachments/ChromeStandaloneSetup64.exe`} download="谷歌浏览器.exe">64位</a>
    </div>
  )
};

export default Download;

